import React from 'react';
import CountUp from 'react-countup';
import { useHistory } from "react-router-dom";

import Contact from '../Contact';
import {
  Section, Container, ContactSection,
} from 'components';
import {
  CompanyPhone, DownloadCount, FacebookSubscriber,
  NaverPostFollwer, NaverBlogVisit, NaverRankPercent,
  ShopCount, ContractRate,
} from 'variables';
import {
  Home01, Home01Mobile, Home02, Home02Mobile,
  Home03, Home03Mobile, Home04, Home04Mobile,
} from 'assets';
import {
  Content, ImageWrapper, Image, Board, Number, Count,
  Label, Circle, CircleTitle, CircleNumber, LineBreak,
  Interview, InterviewItem,
} from './style';

const Home: React.FC = _ => {
  const history = useHistory();

  const goToInterview = (index: number) => {
    history.push(`/case#case_0${index}`);
  };

  return (
    <div>
      <Section minHeight={250}>
        <h1>2030 커플들을 위한 <LineBreak/>데이트코스 추천 앱<br/>6년 연속 데이트코스 앱 분야 1위</h1>
        <a href={`tel:${CompanyPhone.replace(/-/g, '')}`}>{CompanyPhone}</a>
      </Section>
      
      <Container>
        <Content>
          <ImageWrapper mode={"desktop"}>
            <Image src={Home01} />
            <Board>
              <Number>
                <Count>
                  <CountUp end={DownloadCount} duration={1.5} separator={','} />
                </Count>
                <Label>앱 다운로드 수, 데이트 코스 앱 1등</Label>
              </Number>
              <Number>
                <Count>
                  <CountUp end={FacebookSubscriber} duration={1.5} separator={','} />
                </Count>
                <Label>페이스북 총 구독자, 카테고리별 7개 운영</Label>
              </Number>
              <Number>
                <Count>
                  <CountUp end={NaverPostFollwer} duration={1.5} separator={','} />
                </Count>
                <Label>네이버 포스트 팔로워 수</Label>
              </Number>
              <Number>
                <Count>
                  <CountUp end={NaverBlogVisit} duration={1.5} separator={','} />
                </Count>
                <Label>네이버 블로그 일 방문자 수</Label>
              </Number>
              <Number>
                <Count>{`${NaverRankPercent}%`}</Count>
                <Label>네이버 포스트, 블로그 상위 1% 공식 에디터</Label>
              </Number>
            </Board>
          </ImageWrapper>
          <ImageWrapper mode={"mobile"}>
            <Image src={Home01Mobile} />
            <Board>
              <Number>
                <Label>앱 다운로드 수</Label>
                <Count>
                  <CountUp end={DownloadCount} duration={1.5} separator={','} />
                </Count>
              </Number>
              <Number>
                <Label>페이스북 총 구독자</Label>
                <Count>
                  <CountUp end={FacebookSubscriber} duration={1.5} separator={','} />
                </Count>
              </Number>
              <Number>
                <Label>네이버 포스트 팔로워 수</Label>
                <Count>
                  <CountUp end={NaverPostFollwer} duration={1.5} separator={','} />
                </Count>
              </Number>
              <Number>
                <Label>네이버 블로그 일 방문자 수</Label>
                <Count>
                  <CountUp end={NaverBlogVisit} duration={1.5} separator={','} />
                </Count>
              </Number>
              <Number>
                <Label>포스트, 블로그 상위 1% 공식 에디터</Label>
                <Count>{`${NaverRankPercent}%`}</Count>
              </Number>
            </Board>
          </ImageWrapper>
          <ImageWrapper mode={"desktop"}>
            <Image src={Home02} />
          </ImageWrapper>
          <ImageWrapper mode={"mobile"}>
            <Image src={Home02Mobile} />
          </ImageWrapper>
          <ImageWrapper mode={"desktop"}>
            <Image src={Home03} />
            <Interview>
              <InterviewItem onClick={() => goToInterview(1)} />
              <InterviewItem onClick={() => goToInterview(2)} />
              <InterviewItem onClick={() => goToInterview(3)} />
            </Interview>
          </ImageWrapper>
          <ImageWrapper mode={"mobile"}>
            <Image src={Home03Mobile} />
            <Interview mode="mobile">
              <InterviewItem onClick={() => goToInterview(1)} />
              <InterviewItem onClick={() => goToInterview(2)} />
              <InterviewItem onClick={() => goToInterview(3)} />
            </Interview>
          </ImageWrapper>

          <ImageWrapper mode={"desktop"}>
            <Image src={Home04} />
            <Circle>
              <CircleTitle>총 제휴점</CircleTitle>
              <CircleNumber>{ShopCount}</CircleNumber>
            </Circle>
            <Circle>
              <CircleTitle>재계약률</CircleTitle>
              <CircleNumber>{`${ContractRate}%`}</CircleNumber>
            </Circle>
            <Circle>
              <CircleTitle>앱 일일 방문자</CircleTitle>
              <CircleNumber>8만명</CircleNumber>
            </Circle>
          </ImageWrapper>
          <ImageWrapper mode={"mobile"}>
            <Image src={Home04Mobile} />
            <Circle>
              <CircleTitle>총 제휴점</CircleTitle>
              <CircleNumber>{ShopCount}</CircleNumber>
            </Circle>
            <Circle>
              <CircleTitle>재계약률</CircleTitle>
              <CircleNumber>{`${ContractRate}%`}</CircleNumber>
            </Circle>
            <Circle>
              <CircleTitle>앱 일일 방문자</CircleTitle>
              <CircleNumber>8만명</CircleNumber>
            </Circle>
          </ImageWrapper>
        </Content>
      </Container>

      <Contact isHome />
      <ContactSection />
    </div>
  );
};

export default Home;
